import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=bdeb0708&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"
import style0 from "./orgManage.vue?vue&type=style&index=0&id=bdeb0708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb0708",
  null
  
)

export default component.exports